//课程管理相关 api
import request from '@/api/request'
import axios from 'axios'

// 详细信息
export function detailApi(id:string) {
    let url = '/api/manager/fillcheck/detail';
    
    let data = {
        "id":id
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}

// 补签信息
export function buqianApi(data:any) {
    let url = '/api/manager/fillcheck/';
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function fillCheckDirectApi(uid:string,sid:string) {
    let url = '/api/manager/fillcheck/direct';
    let data = {
        "uid" : uid,
        "sid" : sid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function fillCheckDirectByIdApi(id:any) {
    let url = '/api/manager/fillcheck/direct/id';
    let data = {
        id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function fillcheckCancelApi(uid:string,sid:string) {
    let url = '/api/manager/fillcheck/cancel';
    let data = {
        "uid" : uid,
        "sid" : sid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}


export function usersApi(users:string,studyclasses:any) {
    let url = '/api/manager/fillcheck/users';
    let data = {
        "users" : users,
        "studyclasses":studyclasses
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function cancelApi(users:string,studyclasses:any) {
    let url = '/api/manager/fillcheck/cancel-user';
    let data = {
        "users" : users,
        "studyclasses":studyclasses
    }

    return axios({
        url,
        data,
        method: 'post',
        responseType: 'blob',
        timeout: 30 * 10 * 1000 // 默认最长时间30秒
    })
}
